import type { MonoIconType } from '@/components/ui/MonoIcon';

/** Discord ChannelType for directory channels (text, announcement, forum parent, etc.) */
export function getDiscordChannelIcon(type: number): MonoIconType {
  if (type === 5) return 'Megaphone';
  if (type === 15) return 'ChatBubble';
  return 'Hash';
}
